import React from "react";
import { FiActivity, FiCast, FiMap } from "react-icons/fi";
import { Link } from "react-router-dom";

const ServiceList = [
  {
    icon: <FiActivity />,
    title: "Урамшуулал",
    description: "Нэг төлөөд 3 сар бэлгийн боловсролын мэдээлэл авах боломж",
  },
  {
    icon: <FiCast />,
    title: "Хонжвор",
    description:
      "1000 хэрэглэгч тутамд 2р хэрэглэгчид 1 сая төгрөгийн урамшуулал",
  },
  {
    icon: <FiMap />,
    title: "Болвосрол",
    description: "Бэлгийн боловсрол бол хүн төрөлхтний хамгийн том зүйл юм",
  },
];

const ServiceOne = ({ textAlign, serviceStyle }) => {
  return (
    <div className="row row--15 service-wrapper">
      {ServiceList.map((val, i) => (
        <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
          <div className={`service ${serviceStyle} ${textAlign}`}>
            <div className="icon">{val.icon}</div>
            <div className="content">
              <h4 className="title w-600">
                <Link
                  to="#service"
                  dangerouslySetInnerHTML={{ __html: val.title }}
                ></Link>
              </h4>
              <p
                className="description b1 color-gray mb--0"
                dangerouslySetInnerHTML={{ __html: val.description }}
              ></p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
export default ServiceOne;
